import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_root/integrations/terraform-backend/hcp-cloud',
)({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.breadcrumb.hcpCloud' }),
  }),
});

function RouteComponent() {
  return <Outlet />;
}
